import { isApiError } from '@/helpers/apiClient'
import { refreshTenantSession, useDashboardScope } from './DashboardScope'

/**
 * A mutation `onError` for dashboard actions. A 403 means the session is stale
 * (the organization was suspended, or the user's role changed since sign-in),
 * so it re-reads the session and the page catches up: banner shown, controls
 * hidden.
 */
export function useRefreshOnForbidden(): (error: Error) => void {
  const scope = useDashboardScope()
  return (error) => {
    if (!isApiError(error) || error.status !== 403) return
    const refresh = refreshTenantSession(scope)
    if (refresh) void refresh
  }
}
